import { Carousel } from "@mantine/carousel";
import { Box, Image } from "@mantine/core";
import { Navigate, Outlet } from "react-router-dom";
import { useRef } from "react";
import Autoplay from "embla-carousel-autoplay";
import banner from "assets/images/pngs/banner.png";
import useAuth from "@/hooks/useAuth";
import RoutesString from "@/pages/routesString";
import ImgBg from "@/assets/images/pngs/left-bg-login.png";
import ImgBgEn from "@/assets/images/pngs/left-bg-login-en.png";
import { useTranslation } from "react-i18next";

const AuthLayout = () => {
  const { isAuthenticated } = useAuth();
  // Ảnh nền cột trái có chữ IN CỨNG trong ảnh nên phải đổi theo ngôn ngữ — i18n không lo được.
  const { i18n } = useTranslation();
  const leftBg = i18n.language?.startsWith("en") ? ImgBgEn : ImgBg;
  const images = [banner, banner];
  const autoplay = useRef(Autoplay({ delay: 2000 }));

  const slides = images.map((url, index) => (
    <Carousel.Slide key={`${index + 1}`}>
      <Image
        fit="cover"
        src={url}
        withPlaceholder
        alt="ad"
        key={`ad_${index + 1}`}
        width="100%"
        sx={{
          height: "100%",
          objectFit: "cover",
          borderRadius: "8px",
        }}
      />
    </Carousel.Slide>
  ));
  if (isAuthenticated) {
    return <Navigate to={RoutesString.Dashboard} replace />;
  }
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        width: "100%",
        backgroundColor: "#F8F9FB",
      }}
    >
      {/* Left box (carousel) */}
      {/* <Box
        sx={{
          position: "relative",
          display: "flex",
          width: "512px",
          paddingTop: "24px",
          paddingBottom: "24px",
          paddingLeft: "32px",
          flexShrink: 0,
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
          overflow: "hidden",
          "& img": {
            maxWidth: "100% !important",
            maxHeight: "100% !important",
          },
        }}
      >
        <Carousel
          height="100%"
          mx="auto"
          withIndicators
          loop
          slideGap="sm"
          plugins={[autoplay.current]}
          onMouseEnter={autoplay.current.stop}
          onMouseLeave={autoplay.current.reset}
          sx={{
            width: "100%",
            "& .mantine-Carousel-viewport": {
              borderRadius: "8px",
            },
          }}
        >
          {slides}
        </Carousel>
      </Box> */}
      {/* Right box (content) */}
      {/* <Box
        sx={{
          display: "flex",
          flex: 3,
          minWidth: "846px",
          flexDirection: "column",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
          height: "100%",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.03)",
        }}
      >
        <TopBar />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "514px",

              margin: "0 auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </Box>
        <BottomBar />
      </Box> */}

      <Box
        h="100vh"
        bg={`url(${leftBg})`}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center bottom",
          backgroundRepeat: "no-repeat",
          width: "50%",
        }}
      />
      {/*
        #55950: khung ngoài đặt overflow:"hidden" nên cột phải bị CẮT phần vượt quá
        100vh — màn Quên mật khẩu (5 ô nhập, bản tiếng Anh nhãn dài hơn) mất hẳn ô
        "Số điện thoại" và nút Tiếp tục trên cửa sổ thấp, cuộn cũng không thấy.
        Cho riêng cột nội dung tự cuộn.
      */}
      <Box
        sx={{
          width: "52%",
          backgroundColor: "white",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AuthLayout;
